<script setup lang="ts">
import type { AiNodeAttributes } from "../ai/types";
import type { CommandItemBaseProps } from "./types";
import { BotIcon } from "lucide-vue-next";
import { newGuid } from "@/common/lib/string";
import { useJustCreatedAiNode } from "../ai/useJustCreatedAiNode";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps & {
  title: string;
  aiAttributes: Pick<AiNodeAttributes, "ask" | "prompt" | "text">;
}>();

const isJustCreated = useJustCreatedAiNode();

function run() {
  const id = newGuid();

  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ onlyIfEmpty: true }))
    .setAiNode({
      id,
      text: props.aiAttributes.text,
      prompt: props.aiAttributes.prompt,
      ask: props.aiAttributes.ask,
    })
    .run();

  isJustCreated.id.value = id;
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="BotIcon"
    @click="run"
    @pointerdown.prevent
    @keydown.enter="run"
  >
    {{ title }}
  </SuggestionListItem>
</template>
